import ReadingsChart from '../../../components/readings-chart'
import merge from 'lodash.merge'
import roundTo from 'round-to'

const temperatureChart = (chartEl, options = {}) => {

  options = merge({
    valueConversion: value => {

      let newValue = null;

      if(window.currentUser.temp_pref === 'C') {
        newValue = window.celsiusToUserTemp(value, 1);
      } else {
        newValue = window.celsiusToUserTemp(value, 1);
      }

      return newValue;

    },
  }, options);

  const chart = new ReadingsChart(chartEl, options);

};

export default temperatureChart;
